import { makeStyles2 } from '../../core';

const appsOptionStyles = () => ({
  appOptionContainer: {
    position: 'relative',
  },
});

export default makeStyles2(appsOptionStyles);
